import React from 'react';
import SearchResultsRow from './search-results-row';

const SearchResults = props => {
  const guitarRows = props.filteredGuitars.map(h => (
    <SearchResultsRow
      key={h.id.toString()}
      guitar={h}
      setActiveGuitar={props.setActiveGuitar}
    />
  ));
  return (
    <div className="mt-2">
      <h4>Results for {props.brand}:</h4>
      <table className="table table-hover">
        <tbody>{guitarRows}</tbody>
      </table>
    </div>
  );
};

export default SearchResults;



// WEBPACK FOOTER //
// ./src/search-results/index.js